// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    overflow-y: hidden !important;
}

.main-container {
    display: flex;
    gap: 10px;
    margin-top: 8px;
    margin-right: 10px;
}

.twitter-post-header-search,
.facebook-post-header-search {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
    justify-content: flex-start;
    width: 100%;
    margin-bottom: 10px;
}

.twitter-post-header-search input,
.facebook-post-header-search input {
    width: 30%;
    padding: 8px;
    font-size: 12px;
    border-radius: 6px;
    /* border: 1px solid #ccc; */
    height: 16px;
}

.date-filters {
    display: flex;
  
    gap: 10px; /* Space between start and end date */
    width: auto;
}

.date-filters .MuiOutlinedInput-root {
    height: 35px;
    font-size: 12px;
    width: 165px; /* Adjust width */
}
.search-button {
    padding: 11px;
    background-color: #65ccb7;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: white;
    display: flex
;
    align-items: center;
    justify-content: center;
    width: 15%;
}
.search-button:hover {
    background-color: #57bba5;
}
.left-section-main {
    transition: width 0.3s ease-in-out;
    width: 70%;
}

.left-section-main.expanded {
    width: 70%;
    margin-left: 14%;
}
.collapse-btn {
    position: absolute;
    margin-left: 5px;
    top: 6%;
    transform: translateY(-50%);
    background-color: #65ccb7;
    color: white;
    border: none;
    padding: 8px 18px;
    cursor: pointer;
    border-radius: 10px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15); /* Soft shadow for depth */
    transition: all 0.3s ease-in-out;
    white-space: nowrap; /* Prevents text from breaking */
    z-index: 100000;
}

.collapse-btn:hover {
    background-color: #57bba5; /* Darker blue on hover */
}

/* Ensures only the button is visible when collapsed */
.right-section-main.collapsed {
    width: 80px;
    min-width: 50px;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 30px;
    top: 10px;
    bottom: 0;
}

.right-section-main.collapsed * {
    display: none; /* Hides all content */
}

/* Keep the button always visible */
.right-section-main.collapsed .collapse-btn {
    display: flex !important;
}

.right-section-main h2, .left-section-main h2 {
    text-align: center;
}

.sidebar.collapsed + .notam_content {
    margin-left: 100px;
}

.notam_content {
    margin-left: 280px;
}

.social-notam-container {
    overflow-y: auto;
    padding: 4px;
}

.left-right {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.639);
    border-radius: 10px;
    padding: 2px;
}

.left-container, .right-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    border-radius: 10px;
    width: 80%;
}

.left-container.black-bg {
    color: white;
    width: 15%;
    background-color: black;
    height: auto;
}

.left-container.blue-bg {
    color: white;
    width: 15%;
    background-color: #3b5998;
    height: auto;
}

.icon-container img {
    display: flex;
    justify-content: center;
    gap: 10px;
    width: 25px;
    height: 25px;
}

.icon-container {
    align-self: center;
}

.notam-text {
    text-align: center;
}

.icons-right {
    display: flex;
    justify-content: center;
    height: 20px;
    flex-direction: column;
    margin-top: 35px;
    gap: 5px;
}

.icons-right svg {
    color: #65CCb7;
}
.notam-description {
    text-align: justify;
    word-break: break-word; /* Ensures long words or URLs break properly */
    overflow-wrap: break-word; /* Alternative for breaking long content */
    white-space: normal; /* Prevents text from stretching in one line */
}
.notam-description-card {
    background-color: #f9f9f9;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 100%; /* Prevents content from overflowing */
    overflow: hidden; /* Ensures extra content doesn’t spill out */
}


.image-container {
    display: grid;
    gap: 2px;
    margin-top: 10px;
}

.image-container.single-image {
    grid-template-columns: 1fr;
}

.image-container.multiple-images {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
}

.twitter-fixed-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: #000000;
    padding: 10px;
    border-bottom: 1px solid #ddd;
    color: white;
}


  
  .twitter-icon {
    width: 20px; /* Adjust size as needed */
    height: 20px;
    margin-right: 10px; /* Space between icon and text */
  }
  
.facebook-fixed-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: #3b5998;
    padding: 10px;
    border-bottom: 1px solid #ddd;
    color: #dbdbdb;
}
.facebook-icon {
    width: 20px; /* Adjust size as needed */
    height: 20px;
    margin-right: 10px; /* Space between icon and text */
  }
.clear-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-left: 5px;
}

.grid-image {
    width: 100%;
    height: 100%;
    max-height: 200px;
    object-fit: contain;
    border-radius: 5px;
}

.filters {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.filters select {
    width: 240px;
    padding: 10px;
    font-size: 16px;
    border-radius: 10px;
    background-color: white;
    border: 1px solid #ccc;
}

.left-section-main::-webkit-scrollbar,
.right-section-main::-webkit-scrollbar {
    width: 8px;
}

.left-section-main::-webkit-scrollbar-thumb,
.right-section-main::-webkit-scrollbar-thumb {
    background-color: #65CCb7;
    border-radius: 0px 10px 10px 0px;
}

.left-section-main::-webkit-scrollbar-track,
.right-section-main::-webkit-scrollbar-track {
    background-color: #e0e0e0;
    border-radius: 0px 10px 10px 0px;
}

.left-section-main::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10px;
    background: linear-gradient(90deg, #000000, #65CCB7, #000000);
    border-radius: 10px 10px 0 0;
    animation: GradientBorder 6s ease infinite;
}

.right-section-main::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10px;
    background: linear-gradient(90deg, #3b5998, #65CCB7, #3b5998);
    border-radius: 10px 10px 0 0;
    animation: GradientBorder 6s ease infinite;

}


.left-section,
.right-section{
    /* margin-top: 10px; */
    overflow-y: scroll;
    height: 85%;
}
.left-section-main,
.right-section-main {
    position: relative;
    margin-bottom: 20px;
    background-color: #ffffff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.639);
    border-radius: 10px;
    overflow-y: hidden;
    height: calc(100vh - 40px);
    padding: 10px;
    border-radius: 10px;
    width: 70%;
    z-index: 10;
}

.notam-profile-info {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.profile-picture {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
}

.username {
   
    font-weight: bold;
    color: #333;
}

.highlight {
    background-color: yellow; /* Background color for highlighted text */
    font-weight: bold;
    color: black; /* Text color for visibility */
  }
  

@keyframes GradientBorder {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}
/* Loader for the button */
.loader-small {
    border: 3px solid #f3f3f3; /* Light grey color for the border */
    border-top: 3px solid #3498db; /* Blue color for the top part */
    border-radius: 50%;
    width: 16px; /* Smaller size for the loader */
    height: 16px;
    animation: spin 1s linear infinite; /* Spinner animation */
  }
  
  /* Animation for spinning */
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .read-more-btn {
    background-color: #007BFF;
    color: white;
    border: none;
    padding: 5px 7px;
    border-radius: 10px;
    cursor: pointer;
    font-weight: revert-layer;
    font-size: 12px;
    transition: background-color 0.3sease, transform 0.2sease;
    display: inline-block;
    text-align: center;
    margin-top: 10px;
  }
  
  .read-more-btn:hover {
    background-color: #0056b3; /* Darker blue on hover */
    transform: scale(1.05); /* Slightly enlarges the button on hover */
  }
  
  .read-more-btn:focus {
    outline: none; /* Removes the outline when the button is focused */
  }
  
  .read-more-btn:active {
    background-color: #004085; /* Even darker blue when the button is clicked */
  }
  

  /* Modal background */
.notam-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8); /* Dark background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* Make sure modal is on top */
  }
  
  /* Modal content (the image container) */
  .notam-modal-content {
    position: relative;
    max-width: 90%;
    max-height: 90%;
    background-color: #fff;
    padding: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  }
  
  .notam-modal-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  
  /* Close button */
  .notam-close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 18px;
    border-radius: 50%;
  }
  
  .notam-close-btn:hover {
    background: rgba(0, 0, 0, 0.8);
  }
  `, "",{"version":3,"sources":["webpack://./src/notam/NotamGrid.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,aAAa;;IAEb,SAAS,EAAE,qCAAqC;IAChD,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY,EAAE,iBAAiB;AACnC;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ;AACJ;IACI,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,OAAO;IACP,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC,EAAE,0BAA0B;IACrE,gCAAgC;IAChC,mBAAmB,EAAE,gCAAgC;IACrD,eAAe;AACnB;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;AACxD;;AAEA,sDAAsD;AACtD;IACI,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;AACb;;AAEA;IACI,aAAa,EAAE,sBAAsB;AACzC;;AAEA,mCAAmC;AACnC;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,4CAA4C;IAC5C,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,sBAAsB,EAAE,8CAA8C;IACtE,yBAAyB,EAAE,0CAA0C;IACrE,mBAAmB,EAAE,8CAA8C;AACvE;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,eAAe,EAAE,sCAAsC;IACvD,gBAAgB,EAAE,4CAA4C;AAClE;;;AAGA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,6BAA6B;IAC7B,YAAY;AAChB;;;;EAIE;IACE,WAAW,EAAE,0BAA0B;IACvC,YAAY;IACZ,kBAAkB,EAAE,gCAAgC;EACtD;;AAEF;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,6BAA6B;IAC7B,cAAc;AAClB;AACA;IACI,WAAW,EAAE,0BAA0B;IACvC,YAAY;IACZ,kBAAkB,EAAE,gCAAgC;EACtD;AACF;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;IAEI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,6DAA6D;IAC7D,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,6DAA6D;IAC7D,4BAA4B;IAC5B,0CAA0C;;AAE9C;;;AAGA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;AACA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;IAC5C,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,wBAAwB,EAAE,0CAA0C;IACpE,iBAAiB;IACjB,YAAY,EAAE,8BAA8B;EAC9C;;;AAGF;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,2BAA2B;IAC/B;AACJ;AACA,0BAA0B;AAC1B;IACI,yBAAyB,EAAE,oCAAoC;IAC/D,6BAA6B,EAAE,gCAAgC;IAC/D,kBAAkB;IAClB,WAAW,EAAE,gCAAgC;IAC7C,YAAY;IACZ,kCAAkC,EAAE,sBAAsB;EAC5D;;EAEA,2BAA2B;EAC3B;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,yDAAyD;IACzD,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB,EAAE,yBAAyB;IACpD,sBAAsB,EAAE,0CAA0C;EACpE;;EAEA;IACE,aAAa,EAAE,mDAAmD;EACpE;;EAEA;IACE,yBAAyB,EAAE,gDAAgD;EAC7E;;;EAGA,qBAAqB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC,EAAE,oBAAoB;IAC1D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,8BAA8B;EAC/C;;EAEA,wCAAwC;EACxC;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC","sourcesContent":["body {\r\n    overflow-y: hidden !important;\r\n}\r\n\r\n.main-container {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-top: 8px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.twitter-post-header-search,\r\n.facebook-post-header-search {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    flex-wrap: nowrap;\r\n    justify-content: flex-start;\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.twitter-post-header-search input,\r\n.facebook-post-header-search input {\r\n    width: 30%;\r\n    padding: 8px;\r\n    font-size: 12px;\r\n    border-radius: 6px;\r\n    /* border: 1px solid #ccc; */\r\n    height: 16px;\r\n}\r\n\r\n.date-filters {\r\n    display: flex;\r\n  \r\n    gap: 10px; /* Space between start and end date */\r\n    width: auto;\r\n}\r\n\r\n.date-filters .MuiOutlinedInput-root {\r\n    height: 35px;\r\n    font-size: 12px;\r\n    width: 165px; /* Adjust width */\r\n}\r\n.search-button {\r\n    padding: 11px;\r\n    background-color: #65ccb7;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    color: white;\r\n    display: flex\r\n;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 15%;\r\n}\r\n.search-button:hover {\r\n    background-color: #57bba5;\r\n}\r\n.left-section-main {\r\n    transition: width 0.3s ease-in-out;\r\n    width: 70%;\r\n}\r\n\r\n.left-section-main.expanded {\r\n    width: 70%;\r\n    margin-left: 14%;\r\n}\r\n.collapse-btn {\r\n    position: absolute;\r\n    margin-left: 5px;\r\n    top: 6%;\r\n    transform: translateY(-50%);\r\n    background-color: #65ccb7;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 18px;\r\n    cursor: pointer;\r\n    border-radius: 10px;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15); /* Soft shadow for depth */\r\n    transition: all 0.3s ease-in-out;\r\n    white-space: nowrap; /* Prevents text from breaking */\r\n    z-index: 100000;\r\n}\r\n\r\n.collapse-btn:hover {\r\n    background-color: #57bba5; /* Darker blue on hover */\r\n}\r\n\r\n/* Ensures only the button is visible when collapsed */\r\n.right-section-main.collapsed {\r\n    width: 80px;\r\n    min-width: 50px;\r\n    background-color: transparent;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: absolute;\r\n    right: 30px;\r\n    top: 10px;\r\n    bottom: 0;\r\n}\r\n\r\n.right-section-main.collapsed * {\r\n    display: none; /* Hides all content */\r\n}\r\n\r\n/* Keep the button always visible */\r\n.right-section-main.collapsed .collapse-btn {\r\n    display: flex !important;\r\n}\r\n\r\n.right-section-main h2, .left-section-main h2 {\r\n    text-align: center;\r\n}\r\n\r\n.sidebar.collapsed + .notam_content {\r\n    margin-left: 100px;\r\n}\r\n\r\n.notam_content {\r\n    margin-left: 280px;\r\n}\r\n\r\n.social-notam-container {\r\n    overflow-y: auto;\r\n    padding: 4px;\r\n}\r\n\r\n.left-right {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 10px;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.639);\r\n    border-radius: 10px;\r\n    padding: 2px;\r\n}\r\n\r\n.left-container, .right-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    width: 80%;\r\n}\r\n\r\n.left-container.black-bg {\r\n    color: white;\r\n    width: 15%;\r\n    background-color: black;\r\n    height: auto;\r\n}\r\n\r\n.left-container.blue-bg {\r\n    color: white;\r\n    width: 15%;\r\n    background-color: #3b5998;\r\n    height: auto;\r\n}\r\n\r\n.icon-container img {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    width: 25px;\r\n    height: 25px;\r\n}\r\n\r\n.icon-container {\r\n    align-self: center;\r\n}\r\n\r\n.notam-text {\r\n    text-align: center;\r\n}\r\n\r\n.icons-right {\r\n    display: flex;\r\n    justify-content: center;\r\n    height: 20px;\r\n    flex-direction: column;\r\n    margin-top: 35px;\r\n    gap: 5px;\r\n}\r\n\r\n.icons-right svg {\r\n    color: #65CCb7;\r\n}\r\n.notam-description {\r\n    text-align: justify;\r\n    word-break: break-word; /* Ensures long words or URLs break properly */\r\n    overflow-wrap: break-word; /* Alternative for breaking long content */\r\n    white-space: normal; /* Prevents text from stretching in one line */\r\n}\r\n.notam-description-card {\r\n    background-color: #f9f9f9;\r\n    border-radius: 10px;\r\n    padding: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    max-width: 100%; /* Prevents content from overflowing */\r\n    overflow: hidden; /* Ensures extra content doesn’t spill out */\r\n}\r\n\r\n\r\n.image-container {\r\n    display: grid;\r\n    gap: 2px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.image-container.single-image {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n.image-container.multiple-images {\r\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n}\r\n\r\n.twitter-fixed-header {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1000;\r\n    background-color: #000000;\r\n    padding: 10px;\r\n    border-bottom: 1px solid #ddd;\r\n    color: white;\r\n}\r\n\r\n\r\n  \r\n  .twitter-icon {\r\n    width: 20px; /* Adjust size as needed */\r\n    height: 20px;\r\n    margin-right: 10px; /* Space between icon and text */\r\n  }\r\n  \r\n.facebook-fixed-header {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1000;\r\n    background-color: #3b5998;\r\n    padding: 10px;\r\n    border-bottom: 1px solid #ddd;\r\n    color: #dbdbdb;\r\n}\r\n.facebook-icon {\r\n    width: 20px; /* Adjust size as needed */\r\n    height: 20px;\r\n    margin-right: 10px; /* Space between icon and text */\r\n  }\r\n.clear-button {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    margin-left: 5px;\r\n}\r\n\r\n.grid-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    max-height: 200px;\r\n    object-fit: contain;\r\n    border-radius: 5px;\r\n}\r\n\r\n.filters {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.filters select {\r\n    width: 240px;\r\n    padding: 10px;\r\n    font-size: 16px;\r\n    border-radius: 10px;\r\n    background-color: white;\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n.left-section-main::-webkit-scrollbar,\r\n.right-section-main::-webkit-scrollbar {\r\n    width: 8px;\r\n}\r\n\r\n.left-section-main::-webkit-scrollbar-thumb,\r\n.right-section-main::-webkit-scrollbar-thumb {\r\n    background-color: #65CCb7;\r\n    border-radius: 0px 10px 10px 0px;\r\n}\r\n\r\n.left-section-main::-webkit-scrollbar-track,\r\n.right-section-main::-webkit-scrollbar-track {\r\n    background-color: #e0e0e0;\r\n    border-radius: 0px 10px 10px 0px;\r\n}\r\n\r\n.left-section-main::before {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 10px;\r\n    background: linear-gradient(90deg, #000000, #65CCB7, #000000);\r\n    border-radius: 10px 10px 0 0;\r\n    animation: GradientBorder 6s ease infinite;\r\n}\r\n\r\n.right-section-main::before {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 10px;\r\n    background: linear-gradient(90deg, #3b5998, #65CCB7, #3b5998);\r\n    border-radius: 10px 10px 0 0;\r\n    animation: GradientBorder 6s ease infinite;\r\n\r\n}\r\n\r\n\r\n.left-section,\r\n.right-section{\r\n    /* margin-top: 10px; */\r\n    overflow-y: scroll;\r\n    height: 85%;\r\n}\r\n.left-section-main,\r\n.right-section-main {\r\n    position: relative;\r\n    margin-bottom: 20px;\r\n    background-color: #ffffff;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.639);\r\n    border-radius: 10px;\r\n    overflow-y: hidden;\r\n    height: calc(100vh - 40px);\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    width: 70%;\r\n    z-index: 10;\r\n}\r\n\r\n.notam-profile-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.profile-picture {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n}\r\n\r\n.username {\r\n   \r\n    font-weight: bold;\r\n    color: #333;\r\n}\r\n\r\n.highlight {\r\n    background-color: yellow; /* Background color for highlighted text */\r\n    font-weight: bold;\r\n    color: black; /* Text color for visibility */\r\n  }\r\n  \r\n\r\n@keyframes GradientBorder {\r\n    0% {\r\n        background-position: 0% 50%;\r\n    }\r\n    50% {\r\n        background-position: 100% 50%;\r\n    }\r\n    100% {\r\n        background-position: 0% 50%;\r\n    }\r\n}\r\n/* Loader for the button */\r\n.loader-small {\r\n    border: 3px solid #f3f3f3; /* Light grey color for the border */\r\n    border-top: 3px solid #3498db; /* Blue color for the top part */\r\n    border-radius: 50%;\r\n    width: 16px; /* Smaller size for the loader */\r\n    height: 16px;\r\n    animation: spin 1s linear infinite; /* Spinner animation */\r\n  }\r\n  \r\n  /* Animation for spinning */\r\n  @keyframes spin {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  .read-more-btn {\r\n    background-color: #007BFF;\r\n    color: white;\r\n    border: none;\r\n    padding: 5px 7px;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    font-weight: revert-layer;\r\n    font-size: 12px;\r\n    transition: background-color 0.3sease, transform 0.2sease;\r\n    display: inline-block;\r\n    text-align: center;\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .read-more-btn:hover {\r\n    background-color: #0056b3; /* Darker blue on hover */\r\n    transform: scale(1.05); /* Slightly enlarges the button on hover */\r\n  }\r\n  \r\n  .read-more-btn:focus {\r\n    outline: none; /* Removes the outline when the button is focused */\r\n  }\r\n  \r\n  .read-more-btn:active {\r\n    background-color: #004085; /* Even darker blue when the button is clicked */\r\n  }\r\n  \r\n\r\n  /* Modal background */\r\n.notam-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.8); /* Dark background */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 9999; /* Make sure modal is on top */\r\n  }\r\n  \r\n  /* Modal content (the image container) */\r\n  .notam-modal-content {\r\n    position: relative;\r\n    max-width: 90%;\r\n    max-height: 90%;\r\n    background-color: #fff;\r\n    padding: 20px;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\r\n  }\r\n  \r\n  .notam-modal-image {\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    object-fit: contain;\r\n  }\r\n  \r\n  /* Close button */\r\n  .notam-close-btn {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    color: #fff;\r\n    border: none;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    border-radius: 50%;\r\n  }\r\n  \r\n  .notam-close-btn:hover {\r\n    background: rgba(0, 0, 0, 0.8);\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
